import { useOutlet } from 'react-router-dom';
import Navigation from '../../components/portal/Navigation';
import { NavProvider } from '../../context/NavigationContext';
import { useQuery } from '@tanstack/react-query';
import axios from '../../lib/axios';
import { useAuth } from '../../context/AuthProvider';
import { useBoundStore } from '../../zustand';
import { TimerProvider } from '../../context/TimerContext';
import { checkForAppUpdate } from '../../hooks/use-version-check';

const Portal = () => {
    const setInterventions = useBoundStore((state) => state.setInterventions)
    const setParameters = useBoundStore((state) => state.setParameters)
    const setSpareparts = useBoundStore((state) => state.setSpareparts)
    const setTechnicians = useBoundStore((state) => state.setTechnicians)
    const setMachinebrands = useBoundStore((state) => state.setMachinebrands)
    const setMachinemodels = useBoundStore((state) => state.setMachinemodels)
    const setMachinetypes = useBoundStore((state) => state.setMachinetypes)
    const setTechnicianStock = useBoundStore((state) => state.setTechnicianStock)
    const setDocuments = useBoundStore((state) => state.setDocuments)
    const setTechnician = useBoundStore((state) => state.setTechnician)

    const technician = useBoundStore((state)=>state.technician)

    const { auth } = useAuth()
    const outlet = useOutlet();

    useQuery({
        queryKey: [`interventions`],
        queryFn: async () => {
            await checkForAppUpdate();
            const { data } = await axios.get(`interventions?dbid=${auth.data?.databases[0].dbid}`)
            setInterventions(data)
            return data;
        },
        refetchInterval: 3600000,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true,
    })

    useQuery({
        queryKey: [`technician`],
        queryFn: async () => {
            const { data } = await axios.get(`technician`, {
                params: {
                    dbid: auth.data?.databases[0].dbid,
                    firstname: auth.data?.firstname,
                    lastname: auth.data?.lastname,
                }
            })
            setTechnician(data)
            return data;
        }
    })

    useQuery({
        queryKey: [`parameters`],
        queryFn: async () => {
            const { data } = await axios.get(`parameters?dbid=${auth.data?.databases[0].dbid}`)
            setParameters(data)
            return data;
        }
    })

    useQuery({
        queryKey: [`spareparts`],
        queryFn: async () => {
            const { data } = await axios.get(`spareparts?dbid=${auth.data?.databases[0].dbid}&wagencode=${technician?.m_sWAGENCODE}`)
            setSpareparts(data)
            return data;
        },
        enabled: !!technician
    })

    useQuery({
        queryKey: [`technicians`],
        queryFn: async () => {
            const { data } = await axios.get(`technicians?dbid=${auth.data?.databases[0].dbid}`)
            setTechnicians(data)
            return data;
        }
    })

    useQuery({
        queryKey: [`machinebrands`],
        queryFn: async () => {
            const { data } = await axios.get(`machinebrands?dbid=${auth.data?.databases[0].dbid}`)
            setMachinebrands(data)
            return data;
        }
    })

    useQuery({
        queryKey: [`machinemodels`],
        queryFn: async () => {
            const { data } = await axios.get(`machinemodels?dbid=${auth.data?.databases[0].dbid}`)
            setMachinemodels(data)
            return data;
        }
    })

    useQuery({
        queryKey: [`machinetypes`],
        queryFn: async () => {
            const { data } = await axios.get(`machinetypes?dbid=${auth.data?.databases[0].dbid}`)
            setMachinetypes(data)
            return data;
        }
    })

    useQuery({
        queryKey: [`technician-stock`],
        queryFn: async () => {
            const { data } = await axios.get(`technician/stock?dbid=${auth.data?.databases[0].dbid}`)
            setTechnicianStock(data)
            return data;
        }
    })

    useQuery({
        queryKey: [`documents`],
        queryFn: async () => {
            const { data } = await axios.get(`documents?dbid=${auth.data?.databases[0].dbid}`)
            setDocuments(data)
            return data
        }
    })
    
    return (
    <>
    <NavProvider>
        <TimerProvider>
            <div className='flex-col flex md:flex-row min-h-[100dvh]'>
                <Navigation />
                <main className='flex-1 w-full'>
                    <div className='w-full h-16 bg-neutral-200' id='spacer'></div>
                    {outlet}
                </main>
            </div>
        </TimerProvider>
    </NavProvider>
    </>
  )
}

export default Portal